import { cx } from "@emotion/css";
import Skeleton from "library/Atoms/Skeleton";
import styles from "./LibraryListSkeleton.styles";

const AddressListSkeleton = () => (
  <>
    <Skeleton className={cx(styles.addressItem, "mt-2 mb-4")} />
    <Skeleton className={cx(styles.addressItem, "mt-2 mb-4")} />
    <Skeleton className={cx(styles.addressItem, "mt-2 mb-4")} />
  </>
);

export default AddressListSkeleton;
